module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ind",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "id": "epigraph"
    }
  }, [_c('a', {
    attrs: {
      "id": "start"
    }
  }, [_vm._v("This is the true account, when all was vague, all was silence, without motion and the sky was still empty. This is the first account, the first narrative. There was neither man nor beast, no bird, fish nor crab, no trees, rocks, caves nor canyons, no plants and no shrubs. Only the sky was there.")])]), _c('a', {
    attrs: {
      "id": "start"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('i', [_vm._v("Popol Vuh")]), _vm._v(" of the Quiché Maya")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55dabda4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/6epigraph.vue
// module id = 78
// module chunks = 0